export default __webpack_public_path__ + "images/no-user.b47926916595af2a9d3dc3d59b24af0a.svg";